/* ==========================================================================
   Reduced-motion guard for the GSAP scroll animations - A11Y-13 (#292)
   layout/theme.liquid loads the two cdnjs libraries, then this file, then one
   of the sixteen *-scroll-animations.js assets, all deferred, so they run in
   that order. Every one of the sixteen opens its init with
   `if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;`
   - the collection files' MutationObserver re-init included - so clearing the
   two globals here, for a visitor who asked their system for reduced motion,
   stops every fade and slide in one place and leaves the content where the
   markup and CSS put it. Nothing else in the theme reads the two globals (the
   only other consumer, section-hero-picture-f.js, went with LIQ-05 #131).
   Consolidating the sixteen files is later work (spec decision 7).
   ========================================================================== */
(function () {
  'use strict';
  if (typeof window.matchMedia !== 'function') return;
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.gsap = undefined;
  window.ScrollTrigger = undefined;
})();
